<body class="ltr main-body leftmenu">
    <form>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                                  All Course Branch Records  </h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active" aria-current="page"><a>
                                      Course Branch Data</a></li>
                                <!-- <li class="breadcrumb-item " aria-current="page">
                                      Add Course Branch  </li> -->
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright">
                                    <!-- (click)="addnewrecord('true')" -->
                                      Add New Record  
    
                                </button>
                                <!-- <button type="button" class="btn btn-primary my-2 me-2  btn-icon-text floatright"
                                    >
                                    <i class="fe fe-download-cloud me-2"></i>
                                      Download Report  
                                </button>
    
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
                                    <i class="fe fe-filter me-2"></i> Doc Type
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item>.csv</button>
                                    <button mat-menu-item>pdf</button>
                                </mat-menu> -->
                                <!-- <button type="button" class="btn btn-white btn-icon-text my-2 me-2">
                                                        <i class="fe fe-download me-2"></i> Import
                                                    </button> -->
    
                            </div>
                        </div>
                    </div>
                    <!-- End Page Header -->
    
                    <!-- Row -->
                    <!-- list of faculty start  -->
                    <div class="row row-sm" *ngIf="list">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <h3 class="main-content-label mb-1"><b>
                                                <!-- {{'header.course-data.titleList.CourseList'  -->
                                                     Course Branch List  </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                  Course Branch Data Information  
                                            </p>
                                        </div>
                                        <div class="col-md-5" >
    
                                            <mat-form-field appearance="outline" class="example-full-width" >
                                                <mat-label>Search ...</mat-label>
                                                <input style="color:black;" matInput placeholder="Search"
                                                     >
                                                <mat-icon matSuffix>search</mat-icon>
                                                <!-- <mat-hint>Hint</mat-hint> -->
                                            </mat-form-field>
                                        </div>
                                    </div>
    
                                    <div class="row form-data">
                                        <div class="col-lg-12">
                                            <div class="row align-items-center">
                                                <div class="col-md-4 my-2 my-md-0">
    
                                                </div>
                                                <div class="col-md-1 my-2 my-md-0">
                                                    
                                                </div>
                                                <div class="col-md-1 my-2 my-md-0">
                                                   
                                                </div>
                                                <div class="col-lg-6 text-right">
                                                  
                                                </div>
    
                                            </div>
                                        </div>
                                    </div>
                                    <div class="table-responsive">
                                        <table id="datatable"
                                            class="table table-striped table-bordered text-nowrap text-left">
                                            <thead>
                                                <tr>
    
                                                    <th class="f600" width="20%">
                                                          Branch Code  
    
                                                    </th>
                                                    <th class="f600">
                                                         branch Name  
                                                    </th>
                                                   
                                                    <th class="f600 text-center" width="10%">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody id="table_data">
                                                <tr >
                                                <!-- *ngFor="let Course Branch of Course BranchList;" -->
                                                    
                                                    <td>NA</td>
                                                    <td>NA </td>
                                                    <!-- <td><span class="label-light-primary">Cancelled </span></td>
                                                    <td class="text-success">• Direct</td> -->
                                                    <td class="text-center">
    
                                                        <a class="btn-floating" title="Edit">
                                                            <!-- (click)="editdata('true',Course Branch.DsCode)" -->
                                                            <i class="fa fa-edit"></i>
                                                        </a>
                                                        <a class="btn-floating" title="Delete">
                                                            <!-- (click)="deletee('true',Course Branch.DsCode)" -->
    
                                                            <i class="fas fa-trash"></i>
                                                        </a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- list of faculty end  -->
                    <!-- add of faculty start  -->
                    <div class="row row-sm add-form" *ngIf="list == false ">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="CourseBranch ">
                            <div class="col-lg-12 col-md-12">
    
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton">
                                            <h3 class="main-content-label mb-1"><b>
                                                      Add New Course Branch Record  
                                                </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                  Add New Course Branch Information  
                                            </p>
                                        </div>
                                        <div *ngIf="editButton">
                                            <h3 class="main-content-label mb-1"><b>
                                                      Update Course Branch Record</b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                  Update Selected Course Branch Information
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton">
                                            <h3 class="main-content-label mb-1"><b>
                                                  Delete Course Branch Record  </b></h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                  Delete Selected Course BranchInformation   
                                            </p>
                                        </div>
                                        <div class="row clearfix">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width mt-4">
                                                            <mat-label>
                                                                  Course Branch Code
                                                            </mat-label>
                                                            <input style="color:black;" type="text" maxlength="5" [readonly]="isreadonly"  [readonly]="isreadonlydel"
                                                                placeholder="Course Branch Code" formControlName="DsCode"
                                                                matInput required>
                                                        </mat-form-field>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width mt-4">
                                                            <mat-label>
                                                                  Course Branch Name
                                                            </mat-label>
                                                            <input style="color:black;" type="text" maxlength="25" [readonly]="isreadonlydel"
                                                                placeholder="Course Branch Name"
                                                                matInput required>
                                                        </mat-form-field>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 align-right">
                                                <button type="submit"
                                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                                    *ngIf="submitButton" >
                                                          Submit  
                                                </button>
                                                <button type="submit"
                                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright   btn-raised g-bg-blush2"
                                                    *ngIf="editButton" >
                                                          Update  
                                                </button>
    
                                                <button type="submit"
                                                    class="  btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                                    *ngIf="deleteButton" >
                                                          Delete  
                                                </button>
    
                                                <button type="submit"
                                                    class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                    >
                                                          Back  
                                                </button>
    
    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <!-- list of faculty end  -->
                </div>
            </div>
        </div>
    </form>
    </body>
    